/**
 * Enumerations metier partagees entre l'API et le front.
 *
 * Ces valeurs sont dupliquees a l'identique dans `schema.prisma`. C'est volontaire :
 * le front ne doit pas dependre du client Prisma (qui est une dependance serveur).
 * Un test unitaire verifie que les deux listes restent synchronisees.
 */
export const ROLES = ['CLIENT', 'TECHNICIAN', 'ADMIN'];
export const CYCLE_TYPES = ['BIKE', 'EBIKE'];
export const SLOT_STATUSES = ['AVAILABLE', 'BOOKED', 'BLOCKED'];
export const INTERVENTION_STATUSES = [
    'DRAFT', // panier en cours de constitution, pas encore confirme
    'BOOKED', // creneau reserve par le client
    'CONFIRMED', // confirme par l'administration
    'IN_PROGRESS', // le technicien est sur place
    'DONE', // travail termine, reste a encaisser
    'PAID', // encaisse, dossier clos
    'CANCELLED', // annule (client, technicien ou admin)
    'NO_SHOW', // client absent au rendez-vous
];
export const MEDIA_PHASES = ['BEFORE', 'AFTER'];
export const PAYMENT_METHODS = ['CARD', 'CASH', 'TRANSFER'];
export const PAYMENT_STATUSES = ['PENDING', 'PAID', 'FAILED', 'REFUNDED'];
export const WAITING_LIST_STATUSES = ['PENDING', 'CONTACTED', 'CONVERTED', 'CLOSED'];
/** Jours de la semaine, indexes ISO-8601 (1 = lundi ... 7 = dimanche). */
export const WEEKDAYS = [1, 2, 3, 4, 5, 6, 7];
// --- Libelles francais, utilises par l'interface -----------------------------
export const ROLE_LABELS = {
    CLIENT: 'Client',
    TECHNICIAN: 'Technicien',
    ADMIN: 'Administrateur',
};
export const CYCLE_TYPE_LABELS = {
    BIKE: 'Velo musculaire',
    EBIKE: 'Velo a assistance electrique',
};
export const INTERVENTION_STATUS_LABELS = {
    DRAFT: 'Brouillon',
    BOOKED: 'Reservee',
    CONFIRMED: 'Confirmee',
    IN_PROGRESS: 'En cours',
    DONE: 'Terminee',
    PAID: 'Payee',
    CANCELLED: 'Annulee',
    NO_SHOW: 'Client absent',
};
export const PAYMENT_METHOD_LABELS = {
    CARD: 'Carte bancaire',
    CASH: 'Especes',
    TRANSFER: 'Virement',
};
export const WEEKDAY_LABELS = {
    1: 'Lundi',
    2: 'Mardi',
    3: 'Mercredi',
    4: 'Jeudi',
    5: 'Vendredi',
    6: 'Samedi',
    7: 'Dimanche',
};
//# sourceMappingURL=enums.js.map